import * as dtos from "@/models/dtos";
import InputCheckbox from "@/features/shared/components/form/InputCheckbox.vue";
import InputText from "@/features/shared/components/form/InputText.vue";
import InputCheckboxGroup from "@/features/shared/components/form/InputCheckboxGroup.vue";
import InputTextarea from "@/features/shared/components/form/InputTextarea.vue";

export class CheckboxGroup {
  Item: dtos.DynamicPropertyGroup;
  Metadata: dtos.MetaData;
  Properties = Array<dtos.DynamicProperty>();
  constructor(metadata: dtos.MetaData, item: dtos.DynamicPropertyGroup) {
    this.Item = item;
    this.Metadata = metadata;
  }

  GetCheckboxes(): Array<dtos.DynamicProperty> {
    return this.Metadata.properties.filter((px) => {
      return this.Item.data.keys.includes(px.key);
    });
  }
}

export class FormItemModel {
  id: any;
  item: dtos.DynamicProperty;
  metadata: dtos.MetaData;
  editView: any;
  /**
   *
   */
  constructor(id: any, item: dtos.DynamicProperty) {
    this.id = id;
    this.item = item;
  }
}
export class ApplicantForm {
  /**
   *
   */
  Items: FormItemModel[];
  Applicant: dtos.ApplicantPositionResponse;
  constructor(
    items: FormItemModel[],
    applicant: dtos.ApplicantPositionResponse
  ) {
    this.Items = items;
    this.Applicant = applicant;
  }
}
export class FormItemBuilder {
  metadata: dtos.MetaData;
  Items: FormItemModel[] = [];
  constructor(metadata: dtos.MetaData) {
    this.metadata = metadata;

    this.create();
  }
  addInput(item: dtos.DynamicProperty): FormItemModel {
    return new FormItemModel(InputText, item);
  }
  addInputTextarea(item: dtos.DynamicProperty): FormItemModel {
    return new FormItemModel(InputTextarea, item);
  }
  addCheckbox(item: dtos.DynamicProperty): FormItemModel {
    return new FormItemModel(InputCheckbox, item);
  }
  addCheckboxGroup(item: dtos.DynamicProperty): FormItemModel {
    const propertyJson = JSON.stringify(item);

    const model = new FormItemModel(
      InputCheckboxGroup,
      JSON.parse(propertyJson)
    );
    model.item.data = new dtos.DynamicPropertyGroupItem();
    model.item.data.label = item.placeholder;

    item.data.keys.forEach((element: any) => {
      model.item.data.keys.push(element);
    });
    return model;
  }

  private create(): Array<FormItemModel> {
    this.metadata.properties.forEach((px) => {
      if (px.type === "text") this.Items.push(this.addInput(px));
      else if (px.type === "textarea")
        this.Items.push(this.addInputTextarea(px));
      else if (px.type === "email") this.Items.push(this.addInput(px));
      else if (px.type === "group") {
        this.Items.push(this.addCheckboxGroup(px));
        px.data.keys.forEach((element: any) => {
          const checkboxItem = this.metadata.properties.find((px2) => {
            return px2.key === element;
          });
          this.Items.push(this.addCheckbox(checkboxItem));
        });
      }
    });
    return this.Items;
  }
}

export class FormItem {
  formIndex: 0;

  addInput(): FormItemModel {
    return new FormItemModel(
      InputText,
      this.createProperty("Placeholder", "text")
    );
  }

  addCheckbox(): FormItemModel {
    const item = new FormItemModel(
      InputCheckbox,
      this.createProperty("Placeholder", "checkbox")
    );
    // emit("add", item);
    return item;
  }
  addCheckboxGroup(): FormItemModel {
    const item = new FormItemModel(
      InputCheckboxGroup,
      this.createProperty("Placeholder2", "group")
    );
    item.item.data = new dtos.DynamicPropertyGroupItem();
    item.item.data.label = item.item.placeholder;

    let checkbox = this.addCheckbox().item;
    item.item.data.keys.push(checkbox.key);
    checkbox = this.addCheckbox().item;
    item.item.data.keys.push(checkbox.key);
    return item;
    // emit("add", item);
  }
  createProperty(
    placeholder: string,
    type: string,
    key?: string
  ): dtos.DynamicProperty {
    const item = new dtos.DynamicProperty();
    item.placeholder = placeholder;
    item.type = type;
    item.key = key || "form_" + this.formIndex++;
    return item;
  }
}
